import axios from "axios";
import { ATP_API_URL } from "../apiConfig/apiConfig";
import { PlanIdsHideing } from "../constant/HidePlanIds";

export const SearchPlanDetailsAction = async () => {
  try {
    const response = await axios.get(ATP_API_URL.GetPlanDetails, {
      headers: { "Content-Type": "application/json" },
    });

    const raw = response.data;

    if (!raw?.success || !Array.isArray(raw?.data)) {
      return { success: false, error: "Unexpected response from plan API." };
    }

    // Remove hidden plan IDs
    const filteredPlans = raw.data.filter(
      (variant) => !PlanIdsHideing.includes(variant.planId),
    );

    // Group by planName — same planName → one card, all variants merged
    const planMap = new Map();
    filteredPlans.forEach((variant) => {
      const name = (variant.planName || "").trim();
      if (!planMap.has(name)) planMap.set(name, []);
      planMap.get(name).push(variant);
    });

    // One plan object per unique planName
    // planId = planName string used as unique selection key
    const plans = Array.from(planMap.entries()).map(([planName, variants]) => ({
      planName,
      planId: planName, // use planName as key so selection always matches
      variants,
    }));

    return { success: true, plans };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch plan details.",
    };
  }
};
